import React, { useState } from "react";
import { api } from "@/lib/api";
import { Table, Select, Badge } from "@/components/erp/ui";
import { AccountModal } from "@/components/erp/AccountModal";
import { LoginHistory, fmtLogin } from "@/components/erp/LoginHistory";
import { toast } from "sonner";
import { Pencil, Trash2, ChevronUp, ChevronDown } from "lucide-react";

const Mover = ({ i, n, id, onMove }) => (
  <div className="flex items-center gap-2">
    <span data-testid={`acc-no-${id}`} className="w-6 text-slate-500 tabular-nums">{i + 1}</span>
    <div className="flex flex-col">
      <button data-testid={`acc-up-${id}`} disabled={i === 0} onClick={() => onMove(i, -1)} className="text-slate-400 hover:text-sky-600 disabled:opacity-20" aria-label="Naik"><ChevronUp className="w-4 h-4" /></button>
      <button data-testid={`acc-down-${id}`} disabled={i === n - 1} onClick={() => onMove(i, 1)} className="text-slate-400 hover:text-sky-600 disabled:opacity-20" aria-label="Turun"><ChevronDown className="w-4 h-4" /></button>
    </div>
  </div>
);

export const AccountsTable = ({ accounts, setAccounts, roleList, reload }) => {
  const [edit, setEdit] = useState(null);
  const [hist, setHist] = useState(null);
  const move = async (i, dir) => {
    const next = [...accounts]; [next[i], next[i + dir]] = [next[i + dir], next[i]]; setAccounts(next);
    try { await api.put("/accounts/reorder", { emails: next.map((a) => a.email) }); } catch { toast.error("Gagal menyimpan urutan"); reload(); }
  };
  const setRole = async (email, role) => { try { await api.put("/accounts/role", { email, role }); toast.success("Role diperbarui"); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } };
  const delAcc = async (a) => { if (!window.confirm(`Hapus akun ${a.name} (${a.email})? Semua cara login akun ini dihapus.`)) return; try { await api.delete("/accounts", { params: { email: a.email } }); toast.success("Akun dihapus"); reload(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } };
  const opts = (role) => roleList.some((r) => r.key === role) ? roleList : [...roleList, { key: role, label: role }];
  return (<>
    {edit && <AccountModal acc={edit} roleList={roleList} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); reload(); }} />}
    {hist && <LoginHistory acc={hist} onClose={() => setHist(null)} />}
    <Table testid="accounts-table" columns={["No", "Nama", "Email", "Cara Login", "Login Terakhir", "Role", ""]} rows={accounts} renderRow={(a) => {
      const i = accounts.findIndex((x) => x.email === a.email); const id = a.email.replace(/[^a-z0-9]/gi, "_");
      return (
        <tr key={a.email} data-testid={`acc-row-${id}`} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
          <td className="px-4 py-3 whitespace-nowrap"><Mover i={i} n={accounts.length} id={id} onMove={move} /></td>
          <td className="px-4 py-3 font-medium">{a.name}</td>
          <td className="px-4 py-3 text-slate-500">{a.email}</td>
          <td className="px-4 py-3 whitespace-nowrap space-x-1">{a.google && <Badge>Google</Badge>}{a.password && <Badge>Password</Badge>}</td>
          <td className="px-4 py-3">
            <button data-testid={`acc-last-${id}`} onClick={() => setHist(a)} className="text-left hover:text-sky-600">
              <span className="block text-xs whitespace-nowrap">{fmtLogin(a.last_login)}{a.last_login && ` · ${a.last_login.method === "google" ? "Google" : "Password"}`}</span>
              {a.last_login && <span className="block text-[11px] text-slate-400">{a.last_login.location || "Lokasi tidak diketahui"}</span>}
            </button>
          </td>
          <td className="px-4 py-3 w-48">
            <Select data-testid={`acc-role-${id}`} value={a.role} onChange={(e) => setRole(a.email, e.target.value)}>
              {opts(a.role).map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
            </Select>
            {(a.extra_roles || []).length > 0 && <div className="flex flex-wrap gap-1 mt-1" data-testid={`acc-extra-roles-${id}`}>{a.extra_roles.map((k) => <span key={k} className="text-[10px] px-1.5 py-0.5 rounded bg-sky-50 text-sky-700">+ {roleList.find((r) => r.key === k)?.label || k}</span>)}</div>}
          </td>
          <td className="px-4 py-3 text-right whitespace-nowrap">
            <button data-testid={`acc-edit-${id}`} title="Edit akun" onClick={() => setEdit(a)} className="text-slate-400 hover:text-sky-500 mr-3"><Pencil className="w-4 h-4" /></button>
            <button data-testid={`acc-del-${id}`} disabled={a.role === "owner"} title={a.role === "owner" ? "Owner / Admin tidak bisa dihapus — ubah role dulu" : "Hapus akun"} onClick={() => delAcc(a)} className="text-slate-400 hover:text-rose-500 disabled:opacity-25 disabled:hover:text-slate-400"><Trash2 className="w-4 h-4" /></button>
          </td>
        </tr>
      );
    }} />
  </>);
};
